import { GoogleOAuthProvider } from '@react-oauth/google';
import { useEffect } from "react";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import WebFont from "webfontloader";
import { persistor, store } from "./redux/store";

// import Router, { routes } from "./Router";
import { AIChatProvider } from "./provider/AIChatProvider";
import { LoadingProvider } from "./provider/LoadingProvider";
import { ToastProvider } from "./provider/ToastProvider";
import { routes } from "./routes";
import { setupInterceptors } from "./utils/axiosInstance";

function App() {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Mulish:200,300,400,500,600,700,800,900"],
      },
    });
  }, []);
  setupInterceptors(store)
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider>
          <LoadingProvider>
            {/* <BrowserRouter> */}
            <AIChatProvider>
              <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GG_APP_ID || ''}
              >
                <RouterProvider router={routes} />
                {/* <Router /> */}
              </GoogleOAuthProvider>
            </AIChatProvider>
            {/* </BrowserRouter> */}
          </LoadingProvider>
        </ToastProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
